import { useEffect, type ReactNode } from 'react';
import { X } from 'lucide-react';
import { Dialog, DialogContent, DialogTitle } from '@/components/ui/dialog';

interface ReportModalProps {
    open: boolean;
    onClose: () => void;
    title: string;
    subtitle?: string;
    children: ReactNode;
    /** Largura: 'wide' para tabelas (padrão), 'narrow' para listas curtas. */
    size?: 'wide' | 'narrow';
}

/** Modal padrão das telas de Anunciantes: cabeçalho fixo, corpo rolável, largura de relatório. */
export function ReportModal({ open, onClose, title, subtitle, children, size = 'wide' }: ReportModalProps) {
    // O Dialog do projeto não trata teclado: Esc fecha o modal.
    useEffect(() => {
        if (!open) return;
        const onKey = (e: KeyboardEvent) => { if (e.key === 'Escape') onClose(); };
        window.addEventListener('keydown', onKey);
        return () => window.removeEventListener('keydown', onKey);
    }, [open, onClose]);
    return (
        <Dialog open={open} onOpenChange={(isOpen) => { if (!isOpen) onClose(); }}>
            <DialogContent className={`${size === 'wide' ? 'max-w-6xl' : 'max-w-3xl'} max-h-[90vh] w-[96vw] overflow-hidden p-0 font-mono`}>
                <div className="flex items-start justify-between gap-3 border-b border-border px-5 py-4">
                    <div className="min-w-0">
                        <DialogTitle className="truncate text-base font-semibold text-foreground">{title}</DialogTitle>
                        {subtitle && <p className="mt-0.5 text-[11px] text-muted-foreground">{subtitle}</p>}
                    </div>
                    <button type="button" onClick={onClose} className="rounded p-1 text-muted-foreground hover:bg-accent hover:text-foreground" aria-label="Fechar">
                        <X className="h-4 w-4" />
                    </button>
                </div>
                <div className="max-h-[calc(90vh-64px)] overflow-y-auto p-4 md:p-5">{children}</div>
            </DialogContent>
        </Dialog>
    );
}
